import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiExternalLink } from 'react-icons/fi';
import TransactionStatusIcon from './TransactionStatusIcon';
import './NotificationDialog.css';

const statusColors = {
  confirmed: {
    bg: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    color: '#fff',
    label: 'Confirmed',
  },
  pending: {
    bg: 'linear-gradient(135deg, #fbbf24 0%, #f59e42 100%)',
    color: '#fff',
    label: 'Pending',
  },
  failed: {
    bg: 'linear-gradient(135deg, #ff5858 0%, #f09819 100%)',
    color: '#fff',
    label: 'Failed',
  },
};

const TransactionDetailsModal = ({ open, onClose, details }) => {
  if (!open || !details) return null;
  const status = details.status || 'confirmed';
  const statusConfig = statusColors[status] || statusColors.confirmed;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="notification-dialog-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{ zIndex: 1000 }}
          onClick={onClose}
        >
          <motion.div
            className="modern-modal-glass"
            initial={{ scale: 0.97, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.97, opacity: 0 }}
            onClick={e => e.stopPropagation()}
            style={{
              maxWidth: 380,
              width: '92vw',
              borderRadius: 24,
              boxShadow: '0 8px 32px 0 rgba(31,38,135,0.18)',
              background: 'rgba(28,32,42,0.82)',
              backdropFilter: 'blur(18px)',
              border: '1.5px solid rgba(255,255,255,0.09)',
              margin: '0 auto',
              padding: '0',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <motion.button
              className="close-button"
              onClick={onClose}
              whileHover={{ scale: 1.13 }}
              whileTap={{ scale: 0.93 }}
              style={{
                position: 'absolute',
                top: 18,
                right: 18,
                background: 'rgba(255,255,255,0.13)',
                border: 'none',
                borderRadius: '50%',
                width: 38,
                height: 38,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#fff',
                fontSize: 22,
                zIndex: 2,
                boxShadow: '0 2px 8px 0 rgba(0,0,0,0.10)',
                cursor: 'pointer',
              }}
              aria-label="Close"
            >
              <FiX />
            </motion.button>
            <div style={{ padding: '38px 28px 28px 28px', textAlign: 'center' }}>
              <div
                style={{
                  background: statusConfig.bg,
                  borderRadius: '50%',
                  width: 70,
                  height: 70,
                  margin: '0 auto 18px auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 16px 0 rgba(67,233,123,0.18)',
                }}
              >
                <TransactionStatusIcon status={status} size={38} />
              </div>
              <h2 style={{ fontWeight: 800, fontSize: 24, margin: '0 0 8px 0', color: '#fff', letterSpacing: '-0.5px' }}>{statusConfig.label}</h2>
              <div style={{ color: '#b7f5d8', fontWeight: 500, fontSize: 15, marginBottom: 18 }}>
                Your transaction was successfully confirmed!
              </div>
              <div style={{ textAlign: 'left', margin: '0 auto', maxWidth: 320 }}>
                <div className="tx-detail-row" style={{ marginBottom: 10 }}><span style={{ color: '#b0b8c9' }}>Amount:</span> <b style={{ color: '#fff' }}>{details.amount} {details.symbol}</b></div>
                <div className="tx-detail-row" style={{ marginBottom: 10 }}><span style={{ color: '#b0b8c9' }}>Recipient:</span> <b style={{ color: '#fff', wordBreak: 'break-all' }}>{details.to}</b></div>
                <div className="tx-detail-row" style={{ marginBottom: 10 }}>
                  <span style={{ color: '#b0b8c9' }}>Transaction Hash:</span>
                  <b
                    style={{
                      color: '#38f9d7',
                      background: 'rgba(56,249,215,0.08)',
                      borderRadius: 7,
                      padding: '6px 10px',
                      fontFamily: 'monospace, monospace',
                      fontSize: 13,
                      wordBreak: 'break-all',
                      letterSpacing: '0.01em',
                      display: 'inline-block',
                      marginLeft: 6,
                    }}
                  >
                    {details.txHash}
                  </b>
                </div>
                <div className="tx-detail-row" style={{ marginTop: 18, textAlign: 'center' }}>
                  <a href={details.explorerUrl} target="_blank" rel="noopener noreferrer" className="action-button" style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 7,
                    background: 'linear-gradient(90deg,#43e97b 0%,#38f9d7 100%)',
                    color: '#fff',
                    fontWeight: 700,
                    borderRadius: 8,
                    padding: '10px 18px',
                    fontSize: 15,
                    margin: '0 auto',
                    boxShadow: '0 2px 8px 0 rgba(67,233,123,0.10)',
                    border: 'none',
                    transition: 'background 0.2s',
                  }}>
                    <FiExternalLink /> View on Explorer
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TransactionDetailsModal; 